<template>
    <!-- <card :header-text="'Indices '"> -->
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                    </div>
                </div>
                <div class="col-md-6">
                </div>
                <div class="col-md-3">
                    <goback></goback>
                </div>
            </div>
            <vue-tabs direction="horizontal" @tab-change="getTabData">
                <v-tab title="PMS">
                    <div class="row mb5"></div>
                    <div class="row mb5">
                        <div class="col-md-5 form-group">
                            <div class="mt-2 mb-2">
                                PMS - Complaint Tables
                            </div>
                            <span>
                                <strong>Data for the month ending - {{ pmsTable.month }} {{ pmsTable.year }}</strong>
                            </span>
                        </div>
                        <div>
                            <!-- <datepicker :input-class="'form-control'" :format="'MM-yyyy'" v-model="smaDate"
                                @selected="getSelDate($event)"></datepicker> -->
                        </div>
                    </div>
                    <div class="table-responsive" v-dragscroll="true">
                        <table class="table table-bordered complaint-table" v-if="pmsTable.rows.length > 0">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th style="width: 15%;">Received from</th>
                                    <th>Pending at the end of last month</th>
                                    <th>Received</th>
                                    <th>Resolved</th>
                                    <th>Total Pending</th>
                                    <th>Pending complaints &gt; 3months</th>
                                    <th>Average Resolution time (in days)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in pmsTable.rows" v-bind:key="'pms-row-' + index">
                                    <td>
                                        <input class="complaint-table-input text-center" type="text" v-model="row.sr_no"
                                            readonly />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="text"
                                            v-model="row.received_from" readonly />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.pending_last_month" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.received" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.resolved" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.total_pending" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.pending_gt_3_months" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="text"
                                            v-model="row.avg_resolution_days" />
                                    </td>
                                </tr>
                                <tr class="complaint-grand-total">
                                    <td></td>
                                    <td>Grand Total</td>
                                    <td>{{ getPmsGrandTotal("pending_last_month") }}</td>
                                    <td>{{ getPmsGrandTotal("received") }}</td>
                                    <td>{{ getPmsGrandTotal("resolved") }}</td>
                                    <td>{{ getPmsGrandTotal("total_pending") }}</td>
                                    <td>{{ getPmsGrandTotal("pending_gt_3_months") }}</td>
                                    <td>N.A</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group pull-right">
                            <button @click="savePMSData" type="button" class="btn btn-primary">Save</button>
                        </div>
                    </div>
                </v-tab>
                <v-tab title="RA">
                    <div class="row mb5"></div>
                    <div class="row mb5">
                        <div class="col-md-5 form-group">
                            <div class="mt-2 mb-2">
                                RA - Complaint Tables
                            </div>
                            <span>
                                <strong>Data for the month ending - {{ raTable.month }} {{ raTable.year }}</strong>
                            </span>
                        </div>
                    </div>
                    <div class="table-responsive" v-dragscroll="true">
                        <table class="table table-bordered complaint-table" v-if="raTable.rows.length > 0">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th style="width: 15%;">Received from</th>
                                    <th>Pending at the end of last month</th>
                                    <th>Received</th>
                                    <th>Resolved</th>
                                    <th>Total Pending</th>
                                    <th>Pending complaints &gt; 3months</th>
                                    <th>Average Resolution time (in days)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in raTable.rows" v-bind:key="'ra-row-' + index">
                                    <td>
                                        <input class="complaint-table-input text-center" type="text" v-model="row.sr_no"
                                            readonly />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="text"
                                            v-model="row.received_from" readonly />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.pending_last_month" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.received" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.resolved" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.total_pending" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="number"
                                            v-model="row.pending_gt_3_months" />
                                    </td>
                                    <td>
                                        <input class="complaint-table-input text-center" type="text"
                                            v-model="row.avg_resolution_days" />
                                    </td>
                                </tr>
                                <tr class="complaint-grand-total">
                                    <td></td>
                                    <td>Grand Total</td>
                                    <td>{{ getTableGrandTotal(raTable, "pending_last_month") }}</td>
                                    <td>{{ getTableGrandTotal(raTable, "received") }}</td>
                                    <td>{{ getTableGrandTotal(raTable, "resolved") }}</td>
                                    <td>{{ getTableGrandTotal(raTable, "total_pending") }}</td>
                                    <td>{{ getTableGrandTotal(raTable, "pending_gt_3_months") }}</td>
                                    <td>N.A</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group pull-right">
                            <button @click="saveRAData" type="button" class="btn btn-primary">Save</button>
                        </div>
                    </div>
                </v-tab>
            </vue-tabs>
        </div>
    </div>
    <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "@/assets/mixins/common.js";
import Datepicker from "vuejs-datepicker";
import { VueTabs, VTab } from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.scss'

export default {
    components: { VueTabs, VTab, Datepicker },
    props: ["company"],
    mixins: [commonMixins],
    created() {
        this.getRAData();
        this.getPMSData();
    },
    data() {
        return {
            smaDate: "",
            rawDataType: 0,
            tableFields: [],
            tableRows: [],
            rawDataList: [],
            raDataApi: "/frontend/ra-investor-grievance/display",
            pmsDataApi: "/frontend/pms-investor-grievance/display",
            pmsTable: {
                month: "",
                year: "",
                rows: [],
                grand_total: {
                    pending_last_month: 0,
                    received: 0,
                    resolved: 0,
                    total_pending: 0,
                    pending_gt_3_months: 0,
                },
            },
            raTable: {
                month: "",
                year: "",
                rows: [],
                grand_total: {
                    pending_last_month: 0,
                    received: 0,
                    resolved: 0,
                    total_pending: 0,
                    pending_gt_3_months: 0,
                },
            },
        };
    },
    methods: {
        getSelDate(e) {
            console.log("Selected date", this.getDate(e));
            //this.ddate = e;
            /* if (this.ddate != null) {
                this.fetchDateWiseReturnData();
            } else {
                this.dateWiseReturnData = {};
            } */
        },
        getRAData() {
            this.isLoading = true;
            this.tableOneData = {};
            let myself = this;
            http.get(this.raDataApi, {}, (error, response) => {
                console.log("RA RawData", response);
                console.log(myself.tableFields);
                if (!error && response && response.table_1_monthly_source_wise) {
                    myself.raTable = response.table_1_monthly_source_wise;
                } else {
                    /* myself.raTable = {
                        "month": "September",
                        "year": 2026,
                        "rows": [
                            {
                                "sr_no": 1,
                                "received_from": "Directly from Investors",
                                "pending_last_month": 1.0,
                                "received": 2.0,
                                "resolved": 1.0,
                                "total_pending": 2.0,
                                "pending_gt_3_months": 0.0,
                                "avg_resolution_days": "N.A"
                            },
                            {
                                "sr_no": 2,
                                "received_from": "SEBI (SCORES)",
                                "pending_last_month": 1.0,
                                "received": 2.0,
                                "resolved": 1.0,
                                "total_pending": 2.0,
                                "pending_gt_3_months": 0.0,
                                "avg_resolution_days": "N.A"
                            },
                            {
                                "sr_no": 3,
                                "received_from": "Other Sources (If any)",
                                "pending_last_month": 1.0,
                                "received": 2.0,
                                "resolved": 1.0,
                                "total_pending": 2.0,
                                "pending_gt_3_months": 0.0,
                                "avg_resolution_days": "N.A"
                            }
                        ],
                        "grand_total": {
                            "pending_last_month": 3.0,
                            "received": 6.0,
                            "resolved": 3.0,
                            "total_pending": 6.0,
                            "pending_gt_3_months": 0.0
                        }
                    } */
                }
                myself.isLoading = false;
            }, true);
        },
        getPMSData() {
            this.isLoading = true;
            this.tableOneData = {};
            let myself = this;
            http.get(this.pmsDataApi, {}, (error, response) => {
                console.log("PMS RawData", response);
                console.log(myself.tableFields);
                if (!error && response && response.table_1_monthly_source_wise) {
                    myself.pmsTable = response.table_1_monthly_source_wise;
                } else {
                    /* myself.pmsTable = {
                        "month": "September",
                        "year": 2026,
                        "rows": [
                            {
                                "sr_no": 1,
                                "received_from": "Directly from Investors",
                                "pending_last_month": 1.0,
                                "received": 2.0,
                                "resolved": 1.0,
                                "total_pending": 2.0,
                                "pending_gt_3_months": 0.0,
                                "avg_resolution_days": "N.A"
                            },
                            {
                                "sr_no": 2,
                                "received_from": "SEBI (SCORES)",
                                "pending_last_month": 1.0,
                                "received": 2.0,
                                "resolved": 1.0,
                                "total_pending": 2.0,
                                "pending_gt_3_months": 0.0,
                                "avg_resolution_days": "N.A"
                            },
                            {
                                "sr_no": 3,
                                "received_from": "Other Sources (If any)",
                                "pending_last_month": 1.0,
                                "received": 2.0,
                                "resolved": 1.0,
                                "total_pending": 2.0,
                                "pending_gt_3_months": 0.0,
                                "avg_resolution_days": "N.A"
                            }
                        ],
                        "grand_total": {
                            "pending_last_month": 3.0,
                            "received": 6.0,
                            "resolved": 3.0,
                            "total_pending": 6.0,
                            "pending_gt_3_months": 0.0
                        }
                    } */
                }
                myself.isLoading = false;
            }, true);
        },
        getPmsGrandTotal(fieldName) {
            return this.getTableGrandTotal(this.pmsTable, fieldName);
        },
        getTableGrandTotal(tableData, fieldName) {
            return tableData.rows.reduce((total, row) => {
                return total + (Number(row[fieldName]) || 0);
            }, 0);
        },
        getComplaintPayload(tableData) {
            const currentDate = new Date();
            const currentMonth = this.getMonthName(currentDate.getMonth());
            return {
                month: currentMonth,
                year: currentDate.getFullYear(),
                month_num: this.getMonthNumber(currentMonth),
                sources: tableData.rows.map((row) => {
                    return {
                        received_from: row.received_from,
                        pending_last_month: Number(row.pending_last_month) || 0,
                        received: Number(row.received) || 0,
                        resolved: Number(row.resolved) || 0,
                        pending_gt_3_months: Number(row.pending_gt_3_months) || 0,
                        avg_resolution_days: row.avg_resolution_days,
                    };
                }),
            };
        },
        getMonthNumber(month) {
            const monthList = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];
            return monthList.indexOf(month) + 1;
        },
        getMonthName(monthIndex) {
            const monthList = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];
            return monthList[monthIndex];
        },
        getTabData(tabIndex, newTab, oldTab) {
            console.log(tabIndex, newTab.title, oldTab);
            if (tabIndex == 0) {
                this.getPMSData();
            } else if (tabIndex == 1) {
                this.getRAData();
            }
        },
        savePMSData() {
            const payload = this.getComplaintPayload(this.pmsTable);
            console.log('PMS Post', payload)
            http.post("/frontend/pms-investor-grievance/add", payload, function (
                error,
                response
            ) {
                console.log("PMS POST response: ", response);
                console.log("PMS POST error: ", error);
            });
        },
        saveRAData() {
            const payload = this.getComplaintPayload(this.raTable);
            console.log('RA Post', payload)
            http.post("/frontend/ra-investor-grievance/add", payload, function (
                error,
                response
            ) {
                console.log("RA POST response: ", response);
                console.log("RA POST error: ", error);
            });
        },

    },
    mounted() { },
    watch: {
        data: function () {

        }
    },
    computed: {

    }
};
</script>
<style>
form .col-md-3 {
    width: 40%;
}

.table th.column-sort {
    cursor: pointer;
}

.table td {
    padding: 5px 10px 5px 10px;
}

.complaint-table {
    font-size: 13px;
}

.complaint-table th {
    background: #d8e2f2;
    color: #555;
    text-align: center;
    vertical-align: middle !important;
}

.complaint-table td {
    text-align: center;
    vertical-align: middle !important;
}

.complaint-table-input {
    background: transparent;
    border: 0;
    box-shadow: none;
    width: 100%;
}

.complaint-table-input:focus {
    background: #fff;
    outline: 1px solid #66afe9;
}

.complaint-grand-total {
    font-weight: bold;
}

.complaint-table input[type="number"]::-webkit-outer-spin-button,
.complaint-table input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
.complaint-table input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/complain-table.vue